export default __webpack_public_path__ + "static/matt-roth-resume-ca51361a9c4bdee1e37a9afdd392fe47.pdf";